import PropTypes from 'prop-types';
import { useCallback, useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { FormDrawer } from 'common/components/drawer';
import { FormBody } from 'common/components/drawer';
import { FormFooter } from 'common/components/drawer';
import { useForm } from 'utils/hooks';

import { Button } from 'reactstrap';
import GroupSection from 'views/enums/purchasing-groups/form/sections/group';
import CompanySection from 'views/enums/purchasing-groups/form/sections/company';
import { DrawerState } from 'common/entities/drawer/DrawerTypes';

import {
  createPurchasingGroup,
  editPurchasingGroup,
  importCompaniesToPurchasingGroup
} from 'store/purchasing-groups/actions';

import groupConfig from 'views/enums/purchasing-groups/form/sections/group/config';
import companyConfig from 'views/enums/purchasing-groups/form/sections/company/config';

const footerTextEnums = {
  import: 'IMPORT',
  subgroup: 'ADD',
  create: 'ADD',
  edit: 'EDIT'
};

const DrawerBody = ({ type, drawer, active, refetchData }) => {
  const [isSaving, setIsSaving] = useState();
  const dispatch = useDispatch();
  const config = useMemo(() => (type === 'import' ? companyConfig : groupConfig), [type]);

  const { formState, collectValues, loadValues, resetForm } = useForm(config, {});

  const closeForm = useCallback(() => {
    drawer.close();
  }, [drawer]);

  useEffect(() => {
    if (drawer.isOpen) {
      resetForm();
    }
  }, [drawer.isOpen, resetForm]);

  useEffect(() => {
    if (active && type !== 'create') {
      loadValues(active);
    }
  }, [active, drawer.isOpen, loadValues, resetForm, type]);

  const onSubmit = async () => {
    const values = collectValues();

    if (!values) return;
    setIsSaving(true);

    try {
      if (type === 'create' || type === 'subgroup') {
        await dispatch(createPurchasingGroup(values)).unwrap();
      }

      if (type === 'edit') {
        await dispatch(editPurchasingGroup(values)).unwrap();
      }

      if (type === 'import') {
        const { organization, ...rest } = values;
        const parseValues = {
          ...rest,
          organization_id: organization?.id || null
        };

        await dispatch(importCompaniesToPurchasingGroup(parseValues)).unwrap();
      }

      refetchData();
      setIsSaving(false);
      closeForm();
    } catch (err) {
      setIsSaving(false);
    }
  };

  const Section = type === 'import' ? CompanySection : GroupSection;

  return (
    <>
      <FormDrawer>
        <FormBody>
          <Section formState={formState} active={active} isOpen={drawer?.isOpen} />
        </FormBody>
      </FormDrawer>

      <FormFooter className="p-3 d-flex justify-content-end">
        <Button color="cancel" className="px-0 py-1 me-4" onClick={closeForm} disabled={isSaving}>
          CANCEL
        </Button>

        <Button onClick={onSubmit} disabled={isSaving} color="primary" className="px-4">
          {footerTextEnums[type]}
        </Button>
      </FormFooter>
    </>
  );
};

export default DrawerBody;

DrawerBody.propTypes = {
  type: PropTypes.string.isRequired,
  drawer: DrawerState.isRequired,
  active: PropTypes.shape({
    id: PropTypes.number,
    parent_id: PropTypes.number,
    name: PropTypes.string,
    code: PropTypes.string
  }),
  refetchData: PropTypes.func
};
